import { StyleSheet } from 'react-native';

import { colors } from '../../colors';

/** Icon cell: 24×24 to match Figma; icon (22×19) centered. */
const iconSize = 24;

export const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.errorBannerBg,
    borderColor: colors.errorBannerBorder,
    borderRadius: 4,
    borderWidth: 1,
    flexDirection: 'row',
    minHeight: 58,
    paddingLeft: 5,
    paddingRight: 12,
    paddingVertical: 9
  },
  iconContainer: {
    alignItems: 'center',
    height: iconSize,
    justifyContent: 'center',
    width: iconSize
  },
  message: {
    color: colors.errorBannerText,
    fontSize: 12,
    lineHeight: 16,
    marginTop: 2
  },
  textColumn: {
    flex: 1,
    marginLeft: 9,
    minWidth: 0
  },
  title: {
    color: colors.errorBannerText,
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: 20
  }
});
